import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@weezevent/nacre';
import Styles from '../../../styles/minisite/blocks.module.css';
import { Trans, useTranslation } from 'react-i18next';
import HTMLReactParser from 'html-react-parser';
import UploadImageZoneGemino from '../upload/uploadImageZoneGemino';

export default function BannerBlock({ data, organization, event, handleSubmit, handleDelete }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = React.useState(false);

    const handleBanner = React.useCallback(
        href => {
            setIsOpen(false);
            if (href === 'event-banner') {
                handleSubmit('event_banner', null);
            } else {
                handleSubmit('url', href);
            }
        },
        [handleSubmit]
    );

    let empty = false;
    let renderData = HTMLReactParser(data.trim());
    if (renderData.length === 0 || data === '') {
        empty = true;
        renderData = (
            <div className={Styles['banner-content']}>
                <Icon size="huge" name="image-add" />
                <Trans i18nKey="ticket.event.minisite.block.banner" />
                <div className={Styles['banner-format']}>
                    <Trans i18nKey="ticket.event.minisite.block.banner-format" />
                </div>
            </div>
        );
    }

    return (
        <div className={`${Styles['block-editable']} ${Styles['block-banner']} ${empty ? Styles['block-banner-empty'] : ''}`} onClick={empty ? () => setIsOpen(true) : null}>
            {!empty && (
                <span className={Styles['block-editable-delete']}>
                    <span className={Styles['block-editable-cta']} onClick={() => setIsOpen(true)}>
                        <Icon size="small" name="edit" /> {t('ticket.common.action.edit')}
                    </span>
                    <span className={Styles['block-editable-cta']} onClick={handleDelete}>
                        <Icon name="trash" />
                    </span>
                </span>
            )}
            {renderData}
            <UploadImageZoneGemino
                inModal
                modalOnly
                openModal={isOpen}
                organization={organization}
                event={event}
                onCancel={() => setIsOpen(false)}
                onUpload={href => handleBanner(href)}
                icon={'picture'}
                textInfo={t('ticket.event.minisite.colors_options.dropzone_banner')}
                args={{ blockType: 'banner' }}
                maxSize={5242880}
            />
        </div>
    );
}

BannerBlock.propTypes = {
    organization: PropTypes.object
};
